import React from 'react';
import { NewWayDiscovery, NewWayContent } from './index';

import './new_way.scss';

export class NewWay extends React.Component<{}> {
  render() {
    return (
      <div className="new-way__container grid">
        <div className="new-way__discovery">
          <NewWayDiscovery />
        </div>
        <div className="new-way__content">
          <NewWayContent />
        </div>
      </div>
    );
  }
}
